import React, { useState, useEffect } from 'react';

import queryString from 'query-string';

import { useLocation } from 'react-router-dom';

import UserService from 'services/user.service';

import { IInvitedFragment } from '../interface';

import { PhoneNumberOutput, PhoneNumberParse } from 'utils/PhoneNumber';

import { Row, Column } from 'components/Layout/Grid';
import Text from 'components/Text';
import { Button } from 'components/Button';

import PasswordValitadorBar from 'components/PasswordValitadorBar';
import Form from 'components/Form';
import Input from 'components/Input';

const RegistrationForm: React.FC<IInvitedFragment> = ({ step, setStep }) => {
  const [userData, setUserData] = useState<any>({
    email: '',
    fullName: '',
    phoneNumber: '',
    password: '',
    repeatPassword: '',
    token: '',
  });

  const [passwordStrength, setPasswordStrength] = useState(0);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);

  const location = useLocation();
  const params = queryString.parse(location.search);

  const _userService = new UserService();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    setUserData((data: any) => ({
      ...data,
      token: params.token?.toString()?.replace(/\s/g, '+'),
      email: params.email?.toString(),
      supplierId: params.supplierId?.toString(),
    }));
  }, []);

  async function userRegister() {
    setErrorMessage('');

    if (passwordStrength < 5)
      return setErrorMessage('Senha não contém requisitos mínimos');
    if (!isTermsAccepted)
      return setErrorMessage('É preciso aceitar os *termos de uso*');

    setLoading(true);

    const { email, fullName, password, token, supplierId } = userData;
    const phoneNumber = PhoneNumberParse(userData.phoneNumber);

    await _userService
      .register(email, fullName, phoneNumber, password, token, supplierId)
      .then((result) => {
        if (result?.status !== 200) {
          setLoading(false);
          return setErrorMessage(
            result?.response?.data?.data ||
            'Erro ao efetuar cadastro. Email ou token inválidos'
          );
        }

        return setStep(step + 1);
      });
  }

  return (
    <div className="animated fadeIn pb-4">
      <Text className="text-wrap color-blue-gray">
        Seja bem-vindo ao Custormer Care, uma plataforma de relacionamento da
        Viveo que irá facilitar o seu dia a dia com os processo e
        serviços. Para darmos continuidade ao seu cadastro, por favor, preenche
        os campos abaixo e defina sua senha de acesso.
      </Text>
      <Form id="registration_form" onValidate={userRegister}>
        <Column className="mt-2">
          <Row>
            <Input
              className="w-100"
              type="email"
              value={userData.email}
              disabled
              required
            />
          </Row>
          <Row className="mt-3 flex-1">
            <Input
              className="w-100"
              type="text"
              minLength={3}
              required
              placeholder="Nome Completo"
              onChange={(e: any) =>
                setUserData({ ...userData, fullName: e.target.value })
              }
              value={userData.fullName}
            />
          </Row>
          <Row className="mt-3">
            <Row className="flex-1">
              <Input
                onChange={(e: any) =>
                  setUserData({
                    ...userData,
                    phoneNumber: PhoneNumberOutput(e.target.value),
                  })
                }
                value={userData.phoneNumber}
                placeholder="Telefone"
                className="flex-1 mr-2"
                type="telphone"
                required
              />
              <Text className="text-wrap color-blue-gray font-italic">
                Esse número será utilizado em caso de atendimento via WhatsApp
              </Text>
            </Row>
          </Row>
          <Row className="mt-1">
            <Input
              className="flex-1"
              placeholder="Nova Senha"
              type="password"
              value={userData.password}
              onChange={(e: any) =>
                setUserData({ ...userData, password: e.target.value })
              }
              required
            />
          </Row>
          <Row className="mt-1">
            <Input
              type="password"
              className="flex-1"
              value={userData.repeatPassword}
              name="Confirmar senha"
              compare={{ name: 'Senha', value: userData.password }}
              placeholder="Confirmar Senha"
              onChange={(e: any) =>
                setUserData({ ...userData, repeatPassword: e.target.value })
              }
              required
            />
          </Row>
          {errorMessage && (
            <Text className="color-danger mt-2 animated fadeIn text-wrap-normal" size={14}>
              {errorMessage}
            </Text>
          )}
          <Row className="mt-2">
            <PasswordValitadorBar
              password={userData.password}
              strength={(strength: number) => setPasswordStrength(strength)}
            />
          </Row>
          <Row className="align-center justify-between mt-2">
            <Row className="align-center">
              <input
                id="accept_terms"
                type="checkbox"
                defaultChecked={isTermsAccepted}
                onClick={() => setIsTermsAccepted(!isTermsAccepted)}
              />
              <label htmlFor="accept_terms">
                <Text className="ml-2 color-blue-gray">
                  Estou de acordo com os{' '}
                  <b
                    onClick={() => {
                      window.open(
                        '/files/termo-de-adesao-viveo.pdf',
                        '_blank'
                      );
                    }}
                    className="cursor-pointer"
                    style={{ textDecoration: 'underline' }}
                    role="presentation"
                  >
                    termos de uso
                  </b>
                  .
                </Text>
              </label>
            </Row>
            <Row className="justify-end">
              <Button
                form="registration_form"
                isRequesting={loading}
                disabled={loading}
                className="bg-primary"
                width="auto"
              >
                <Text className="color-white px-3">Confirmar</Text>
              </Button>
            </Row>
          </Row>
        </Column>
      </Form>
    </div>
  );
};

export default RegistrationForm;
